import {Store} from '../classes/store';
import {Injectable, Inject} from '@angular/core';
import {ApiLegacyService} from '../../../services/api/api.service';
import {ElementLog} from './element-log.interface';
import {ProjectElementStore} from '../project-element/project-element-store';
import {ProjectElement} from '../../../resources/element/project-element.interface';
import { Subject, BehaviorSubject } from 'rxjs';
import { ProjectStore } from '../project/project-store';
import { take } from 'rxjs/operators';
import * as moment from 'moment';
import { ToastService } from '../../../services/toast/toast.service';
import { TranslateService } from '../../../utilities/translate/translate.service';

@Injectable({
  providedIn: 'root'
})
export class ElementLogStore extends Store<ElementLog> {

  /** Legacy Auth reference. */
  private _sgAuthService: any;

  /** Constructor. */
  constructor(
    @Inject('sgAuth') sgAuthService: any,
    private projectStore: ProjectStore,
    private translateService: TranslateService,
    private toastService: ToastService,
    private api: ApiLegacyService
  ) {
    super();
    this._sgAuthService = sgAuthService;
  }

  /**
   * For comments, use a 'fake' temporary store.
   *
   * @todo Multiple store types, or a { persistance: boolean } constructor param.
   *  So during bootstrapping a store canr egister itself as non-persistant, while
   *  still keeping the same methods/properties as a regular (persistant) store.
   */
  private _state: Subject<any> = new BehaviorSubject<ElementLog[]>(null);
  public state$ = this._state.asObservable();

  /**
   * Set comments.
   *
   * @param comments Comments.
   */
  set(comments: ElementLog[]): void {
    this._state.next(comments);
  }

  /**
   * Insert new comment.
   *
   * @todo Create shorthands for getting general info.
   *
   * @param comment Comment object.
   */
  insert(comment: ElementLog) {
    comment.projectId = this.projectStore.get()._id;
    comment.versionId = this.projectStore.get().versionId;
    comment.userId = this._sgAuthService.getCurrentUser()._id;

    this.api.addElementComment(comment).$promise.then(response => {
      this.state$.pipe(take(1)).subscribe(comments => {
        this._state.next([
          {
            date: moment().format(),
            text: comment.text,
            type: 'COMMENT',
            userId: comment.userId
          },
          ...comments
        ]);
      });

      this.toastService.open(this.translateService.get('addedcomment'), null, { horizontalPosition: 'left' });
    });
  }

}
